import Filter from './Filter'

export default class MessageFilter extends Filter {
	constructor (filters) {
		super(filters)

		return this.get('page', null, '?page')
			.get('keyword', null, '&keyword')
			.get('type', null, '&type', this.filterType)
			.init()
	}

	filterType ({ filter, value }) {
		const messageType = value !== 'inbox' ? value : ''

		if (messageType) {
			filter.apiQuery += `&type=${messageType.split(' ').join('_')}`
			filter.routerQuery.type = messageType
		}

		return filter
	}
}
